import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toggleRetrieveDialog } from '../../store/slice/dialogSlice'
import { usePostPaymentRetrieveMutation } from '../../store/api/paymentApi'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { usePostOrderRetrieveMutation } from '../../store/api/orderApi'
import { updateReFetch } from '../../store/slice/mainToCardSlice'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import { usePostRequestRetrieveMutation } from '../../store/api/requestApi'
import { usePostVendorRfqRetrieveMutation } from '../../store/api/rfqsApi'

const RetrieveDialog = () => {
  const dispatch = useDispatch()
  const paymentData = useSelector((state) => state.persistSlice.paymentData)
  const orderData = useSelector((state) => state.mainToCard.orderData)
  const requestData = useSelector((state) => state.persistSlice.requestData)
  const vendorRfqData = useSelector((state) => state.mainToCard.vendorRfqData)
  const open = useSelector((state) => state.dialogSlice.retrieveDialog)
  const [postPaymentRetrieve, { isLoading: paymentLoading }] = usePostPaymentRetrieveMutation()
  const [postOrderRetrieve, { isLoading: orderLoading }] = usePostOrderRetrieveMutation()
  const [postRequestRetrieve, { isLoading: requestLoading }] = usePostRequestRetrieveMutation()
  const [postVendorRfqRetrieve, { isLoading: vendorRfqLoading }] = usePostVendorRfqRetrieveMutation()


  const handleClose = () => {
    dispatch(toggleRetrieveDialog())
  }

  let content, action
  const url = useLocation().pathname

  const handleRefresh = () => {
    dispatch(onRefreshButton())
    setTimeout(() => {
      dispatch(offRefreshButton(false))
    }, 1)
  }


  switch (url) {
    case '/payment':
      content = (
        <>
          {paymentData?.length > 0 ? (
            <Typography component="span">
              Are you sure, you want to{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>{' '}
              this Payment Request?
            </Typography>
          ) : (
            <Typography component="span">
              Please select at least one Payment Request for{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>
            </Typography>
          )}
        </>
      )

      action = paymentData?.length > 0 && (
        <Button
          variant="contained"
          disabled={paymentLoading}
          onClick={async () => {
            const paymentDocumentMainIds = paymentData?.map((item) => item.paymentDocumentMainId)
            const data = await postPaymentRetrieve({ paymentDocumentMainIds })

            if (data?.data?.statusCode === 200) {
              showSuccessToast(`Succesfully`)
            } else {
              showErrorToast('Something went wrong')
            }

            handleClose()
          }}
        >
          Retrieve
        </Button>
      )
      break

    case '/orders':
      content = (
        <>
          {orderData?.length > 0 ? (
            <Typography component="span">
              Are you sure, you want to{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>{' '}
              this Orders?
            </Typography>
          ) : (
            <Typography component="span">
              Please select at least one Order for{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>
            </Typography>
          )}
        </>
      )

      action = orderData?.length > 0 && (
        <Button
          variant="contained"
          disabled={orderLoading}
          onClick={async () => {
            const ids = orderData?.map((item) => item.orderMainId)
            const data = await postOrderRetrieve({ ids })
            if (data?.data?.statusCode === 200) {
              showSuccessToast(`Succesfully`)
              dispatch(updateReFetch(true))
            } else if (data?.error?.status === 422) {
              // showErrorToast(`${data?.error?.data?.errors} order no : ${orderData?.map(x => x.orderNo).join(', ')}`)
              showErrorToast(data?.error?.data?.errors)
            } else {
              showErrorToast('Something went wrong')
            }
            handleRefresh();
            handleClose()
          }}
        >
          Retrieve
        </Button>
      )
      break

    case '/requests':
      content = (
        <>
          {requestData?.length > 0 ? (
            <Typography component="span">
              Are you sure, you want to{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>{' '}
              this Requests?
            </Typography>
          ) : (
            <Typography component="span">
              Please select at least one Request for{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>
            </Typography>
          )}
        </>
      )

      action = requestData?.length > 0 && (
        <Button
          variant="contained"
          disabled={requestLoading}
          onClick={async () => {
            const requestMainIds = requestData?.map((item) => item.requestMainId)
            const data = await postRequestRetrieve({ requestMainIds })

            if (data?.data?.statusCode === 200) {
              showSuccessToast(`Succesfully`)
              dispatch(updateReFetch(true))
            } else {
              showErrorToast('Something went wrong')
            }
            handleRefresh();
            handleClose()
          }}
        >
          Retrieve
        </Button>
      )
      break


    case '/rfq-information':
      content = (
        <>
          {vendorRfqData?.length > 0 ? (
            <Typography component="span">
              Are you sure, you want to{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>{' '}
              this Rfq?
            </Typography>
          ) : (
            <Typography component="span">
              Please select at least one Rfq for{' '}
              <Typography component="span" fontWeight={'bold'}>
                Retrieve
              </Typography>
            </Typography>
          )}
        </>
      )

      action = vendorRfqData?.length > 0 && (
        <Button
          variant="contained"
          disabled={vendorRfqLoading}
          onClick={async () => {
            const data = await postVendorRfqRetrieve({ rfqMainId: vendorRfqData?.[0]?.rfqMainId })

            if (data?.data?.statusCode === 200) {
              showSuccessToast(`Succesfully`)
              dispatch(updateReFetch(true))
            } else {
              showErrorToast('Something went wrong')
            }
            handleRefresh();
            handleClose()
          }}
        >
          Retrieve
        </Button>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Retrieve</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default RetrieveDialog